// extracted by mini-css-extract-plugin
export default {"AggregateLabels":"repository-group-header-label-module__AggregateLabels__dQI1azG"};